import { successResponse, errorResponse } from "./SpaceServices.js";
import axios from "axios";

const BACKEND_API = process.env.REACT_APP_BACKEND_API;
let tenantId = localStorage.getItem("tenantId");

export const getStructureDefinition = async (userInfo) => {
    let responseObj = { status: "", message: "", data: [] };
    try {
        let response = await axios({
            method: "GET",
            url: `${BACKEND_API}/orgDef`,
            headers: {
                userId: userInfo?.userId,
                tenantId: tenantId
            },
        })
        if (response.status === 200) {
            responseObj = successResponse(response.data, responseObj, false)
        }
    }
    catch(err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj;
}

export const saveStructureDefinition = async (postData, update=false, userInfo) => {
    let responseObj = { status: "", message: "", data: {} };
    let method = update ? "PUT" : "POST"
    try {
        let response = await axios({
            method: method,
            url: `${BACKEND_API}/orgDef`,
            data: { ...postData },
            headers: {
                userId: userInfo?.userId,
                tenantId: tenantId
            },
        })
        if (response.status === 200) {
            responseObj = successResponse(response.data, responseObj, false)
        }
    }
    catch(err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj;
}

export const deleteStructureDefinition = async (data, userInfo) => {
    let responseObj = { status: "", message: "", data: {} };
    try {
        let response = await axios({
            method: "DELETE",
            url: `${BACKEND_API}/orgDef/${data.orgDefId}`,
            headers: {
                userId: userInfo.userId,
            },
        })
        if (response.status === 200) {
            responseObj = successResponse(response.data, responseObj, false)
        }
    }
    catch(err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj;
}

export const getOrgStructure = async (orgId=1, userInfo) => {
    let responseObj = { status: "", message: "", data: [] };
    try {
        let response = await axios({
            method: "GET",
            url: `${BACKEND_API}/org`,
            headers: {
                userId: userInfo?.userId,
                tenantId: tenantId
            },
        })
        if (response.status === 200) {
            responseObj = successResponse(response.data, responseObj, false)
        }
    }
    catch(err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj;
}

export const saveOrgStructure = async (data, update=true, userInfo) => {
    let responseObj = { status: "", message: "", data: [] };
    try {
        let response = await axios({
            method: update ? "PUT" : "POST",
            url: `${BACKEND_API}/org`,
            data: {...data},
            headers: {
                userId: userInfo?.userId,
                tenantId: tenantId
            },
        })
        if (response.status === 200) {
            responseObj = successResponse(response.data, responseObj, false)
        }
    }
    catch(err) {
        responseObj = errorResponse(err, responseObj, false)
    }
    return responseObj;
}